export default __webpack_public_path__ + "static/media/coldWater.c61445df.jpg";